export default __webpack_public_path__ + "static/media/aboutHeroMobile.0522b9d1.png";